
export const useProjectIdFromURL = () => {
    try{
        const parts = window.location.pathname.split('/')
        const idx = parts.indexOf('project') + 1;
        return parseInt(parts[idx])
    }catch (e) {
    }
    return -1
}